(function () {
  'use strict';

  /**
   * Kaynak secondary-media (Flickity select) hissi:
   * - Her görsel tam ortaya gelir (yarım kare yok)
   * - Mouse X bölgelerine göre slide değişir
   * - Geçiş yumuşak translate animasyonu
   * - Mouse çıkınca ilk görsele döner
   */
  function initCard(card) {
    if (card.getAttribute('data-atc-ready')) return;
    card.setAttribute('data-atc-ready', '1');

    var wrap = card.querySelector('.atc-card__img-wrap');
    if (!wrap) return;

    var track = wrap.querySelector('.atc-card__img-track');
    var slides = Array.from(wrap.querySelectorAll('.atc-card__img-slide'));
    var dots = Array.from(wrap.querySelectorAll('.atc-card__img-dot'));
    var swatches = Array.from(card.querySelectorAll('.atc-card__swatch'));
    if (!slides.length) return;

    if (!track) {
      track = document.createElement('div');
      track.className = 'atc-card__img-track';
      slides.forEach(function (s) {
        track.appendChild(s);
      });
      var link = wrap.querySelector('.atc-card__img-link');
      var host = link || wrap;
      host.insertBefore(track, host.firstChild);
    }

    var count = slides.length;
    var curIdx = -1;
    var prefersHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var hoverTarget = wrap.querySelector('.atc-card__img-link') || wrap;

    function showSlide(i) {
      if (i < 0 || i >= count || i === curIdx) return;
      curIdx = i;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === i);
      });
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === i);
      });
    }

    showSlide(0);

    if (count > 1 && prefersHover) {
      hoverTarget.addEventListener('mousemove', function (e) {
        var rect = hoverTarget.getBoundingClientRect();
        var mouseX = e.clientX - rect.left;
        var width = rect.width;
        var next = Math.min(Math.floor((mouseX / width) * count), count - 1);
        if (next < 0) next = 0;
        showSlide(next);
      });

      hoverTarget.addEventListener('mouseleave', function () {
        showSlide(0);
      });
    }

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        swatches.forEach(function (s) {
          s.classList.remove('is-active');
        });
        sw.classList.add('is-active');
        var newSrc = sw.getAttribute('data-src');
        if (newSrc && slides[0]) {
          var img = slides[0].querySelector('img');
          if (img) img.src = newSrc;
        }
        showSlide(0);
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.atc-card').forEach(initCard);
  }

  /* ——— Quick View modal ——— */
  var productCache = {};
  var qvState = {
    product: null,
    selected: [],
    qty: 1,
    mediaIdx: 0,
    baseMediaIdx: 0,
    images: [],
  };

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
    } catch (e) {}
    try {
      return n.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
    } catch (err) {
      return n.toFixed(2) + ' TL';
    }
  }

  function ensureModal() {
    var el = document.getElementById('atc-qv');
    if (el) return el;

    el = document.createElement('div');
    el.id = 'atc-qv';
    el.className = 'atc-qv';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<div class="atc-qv__overlay" data-atc-qv-close></div>' +
      '<div class="atc-qv__panel" role="dialog" aria-modal="true" aria-labelledby="atc-qv-title">' +
      '<button type="button" class="atc-qv__close" data-atc-qv-close aria-label="Kapat">×</button>' +
      '<div class="atc-qv__body"></div>' +
      '</div>';
    document.body.appendChild(el);

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-atc-qv-close]')) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('is-open')) closeModal();
    });

    return el;
  }

  function openModal() {
    var el = ensureModal();
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal() {
    var el = document.getElementById('atc-qv');
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function setLoading(html) {
    var body = ensureModal().querySelector('.atc-qv__body');
    body.innerHTML = html || '<div class="atc-qv__loading">Yükleniyor…</div>';
  }

  function optionKey(name) {
    return String(name || '').toLowerCase();
  }

  function isColorOption(name) {
    var n = optionKey(name);
    return n === 'color' || n === 'colour' || n === 'renk' || n.indexOf('color') !== -1 || n.indexOf('renk') !== -1;
  }

  function findVariant(product, selected) {
    return (product.variants || []).find(function (v) {
      return selected.every(function (val, i) {
        return String(v['option' + (i + 1)]) === String(val);
      });
    });
  }

  function availableValues(product, optionIndex, selected) {
    var set = {};
    (product.variants || []).forEach(function (v) {
      var ok = true;
      for (var i = 0; i < selected.length; i++) {
        if (i === optionIndex) continue;
        if (selected[i] == null) continue;
        if (String(v['option' + (i + 1)]) !== String(selected[i])) {
          ok = false;
          break;
        }
      }
      if (!ok) return;
      if (!v.available) return;
      set[String(v['option' + (optionIndex + 1)])] = true;
    });
    return set;
  }

  function variantImage(variant, product) {
    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    if (product.featured_image) {
      return typeof product.featured_image === 'string'
        ? product.featured_image
        : product.featured_image.src;
    }
    if (product.images && product.images[0]) {
      return typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
    }
    return '';
  }

  function optionName(opt) {
    if (!opt) return '';
    if (typeof opt === 'string') return opt;
    return opt.name || opt.value || '';
  }

  function productImages(product) {
    var imgs = [];
    (product.images || []).forEach(function (img) {
      var src = typeof img === 'string' ? img : img && img.src;
      if (src && imgs.indexOf(src) === -1) imgs.push(src);
    });
    return imgs;
  }

  function colorHex(name) {
    var n = String(name || '')
      .toLowerCase()
      .trim();
    var map = {
      black: '#111111',
      'carbon black': '#1a1a1a',
      'titan black': '#222222',
      white: '#f5f5f5',
      clear: '#e8e8e8',
      silver: '#c0c0c0',
      gray: '#8a8a8a',
      grey: '#8a8a8a',
      blue: '#2f5f9f',
      'dark blue': '#1e3a5f',
      orange: '#e87a2f',
      pink: '#e8a0b5',
      beige: '#ead8ab',
      rainbow: 'linear-gradient(135deg,#f66,#fc6,#6c6,#69f,#c6f)',
      transparent: '#ececec',
    };
    return map[n] || '';
  }

  function renderModal(opts) {
    opts = opts || {};
    var product = qvState.product;
    if (!product) return;

    var variant = findVariant(product, qvState.selected) || product.variants[0];
    var img = variantImage(variant, product);
    var images = productImages(product);
    if (img && images.indexOf(img) === -1) images = [img].concat(images);
    if (!images.length && img) images = [img];
    qvState.images = images;

    if (opts.fromVariant !== false) {
      var vi = img ? images.indexOf(img) : 0;
      if (vi < 0) vi = 0;
      qvState.baseMediaIdx = vi;
      qvState.mediaIdx = vi;
    }
    if (qvState.mediaIdx == null || qvState.mediaIdx >= images.length) {
      qvState.mediaIdx = qvState.baseMediaIdx || 0;
    }

    var options = product.options || [];
    var optionsHtml = '';

    options.forEach(function (opt, idx) {
      var optName = optionName(opt);
      if (!optName || optName === 'Title') return;
      var values = [];
      if (opt && Array.isArray(opt.values) && opt.values.length) {
        values = opt.values.slice();
      } else {
        (product.variants || []).forEach(function (v) {
          var val = v['option' + (idx + 1)];
          if (val && values.indexOf(val) === -1) values.push(val);
        });
      }
      if (!values.length) return;

      var avail = availableValues(product, idx, qvState.selected);
      var selectedVal = qvState.selected[idx];
      var colorish = isColorOption(optName);

      optionsHtml +=
        '<div class="atc-qv__option" data-option-index="' +
        idx +
        '">' +
        '<p class="atc-qv__option-label">' +
        escapeHtml(optName) +
        ': <span class="atc-qv__option-value">' +
        escapeHtml(selectedVal || '') +
        '</span></p>';

      if (colorish) {
        optionsHtml += '<div class="atc-qv__swatches">';
        values.forEach(function (val) {
          var sample = (product.variants || []).find(function (v) {
            return String(v['option' + (idx + 1)]) === String(val) && v.featured_image;
          });
          var src = sample && sample.featured_image ? sample.featured_image.src : '';
          var hex = colorHex(val);
          var disabled = !avail[String(val)];
          optionsHtml +=
            '<button type="button" class="atc-qv__swatch' +
            (selectedVal === val ? ' is-active' : '') +
            '" data-option-index="' +
            idx +
            '" data-value="' +
            escapeAttr(val) +
            '"' +
            (disabled ? ' disabled' : '') +
            ' title="' +
            escapeAttr(val) +
            '" aria-label="' +
            escapeAttr(val) +
            '"><span class="atc-qv__swatch-inner"' +
            (hex && !src ? ' style="background:' + hex + '"' : '') +
            '>' +
            (src
              ? '<img src="' + escapeAttr(src) + '" alt="' + escapeAttr(val) + '" loading="lazy">'
              : '') +
            '</span></button>';
        });
        optionsHtml += '</div>';
      } else {
        optionsHtml += '<div class="atc-qv__pills">';
        values.forEach(function (val) {
          var disabled = !avail[String(val)];
          optionsHtml +=
            '<button type="button" class="atc-qv__pill' +
            (selectedVal === val ? ' is-active' : '') +
            (disabled ? ' is-unavailable' : '') +
            '" data-option-index="' +
            idx +
            '" data-value="' +
            escapeAttr(val) +
            '"' +
            (disabled ? ' disabled' : '') +
            '>' +
            escapeHtml(val) +
            '</button>';
        });
        optionsHtml += '</div>';
      }
      optionsHtml += '</div>';
    });

    var slidesHtml = '<div class="atc-qv__media-track" style="transform:translateX(-' + qvState.mediaIdx * 100 + '%)">';
    images.forEach(function (src, i) {
      slidesHtml +=
        '<div class="atc-qv__media-slide' +
        (i === qvState.mediaIdx ? ' is-active' : '') +
        '"><img src="' +
        escapeAttr(src) +
        '" alt="' +
        escapeAttr(product.title) +
        (i ? ' ' + (i + 1) : '') +
        '" loading="' +
        (i ? 'lazy' : 'eager') +
        '"></div>';
    });
    slidesHtml += '</div>';

    var dotsHtml = '';
    if (images.length > 1) {
      dotsHtml = '<div class="atc-qv__dots" aria-hidden="true">';
      images.forEach(function (_, i) {
        dotsHtml +=
          '<button type="button" class="atc-qv__dot' +
          (i === qvState.mediaIdx ? ' is-active' : '') +
          '" data-atc-media="' +
          i +
          '" aria-label="Görsel ' +
          (i + 1) +
          '"></button>';
      });
      dotsHtml += '</div>';
    }

    var inStock = variant && variant.available;
    var body = ensureModal().querySelector('.atc-qv__body');
    body.innerHTML =
      '<div class="atc-qv__media">' +
      '<div class="atc-qv__media-frame" data-atc-qv-gallery>' +
      slidesHtml +
      '</div>' +
      dotsHtml +
      '</div>' +
      '<div class="atc-qv__info">' +
      (product.vendor
        ? '<p class="atc-qv__vendor">' + escapeHtml(product.vendor) + '</p>'
        : '') +
      '<div class="atc-qv__head">' +
      '<h2 class="atc-qv__title" id="atc-qv-title">' +
      escapeHtml(product.title) +
      '</h2>' +
      '<p class="atc-qv__price">' +
      money(variant ? variant.price : product.price) +
      '</p>' +
      '</div>' +
      (product.type
        ? '<p class="atc-qv__subtitle">' + escapeHtml(product.type) + '</p>'
        : '') +
      optionsHtml +
      '<p class="atc-qv__stock' +
      (inStock ? '' : ' is-out') +
      '">' +
      (inStock ? 'Stokta, kargoya hazır' : 'Stokta yok') +
      '</p>' +
      '<div class="atc-qv__actions">' +
      '<div class="atc-qv__qty">' +
      '<button type="button" data-atc-qty="-1" aria-label="Azalt">‹</button>' +
      '<input type="number" min="1" value="' +
      qvState.qty +
      '" data-atc-qty-input aria-label="Adet">' +
      '<button type="button" data-atc-qty="1" aria-label="Artır">›</button>' +
      '</div>' +
      '<button type="button" class="atc-qv__add" data-atc-add' +
      (inStock ? '' : ' disabled') +
      '>' +
      (inStock ? 'Sepete ekle' : 'Tükendi') +
      '</button>' +
      '</div>' +
      '<p class="atc-qv__error" hidden data-atc-error></p>' +
      '<a class="atc-qv__details" href="/products/' +
      encodeURIComponent(product.handle) +
      '"><span>Tüm detayları gör</span><span class="atc-qv__details-arrow" aria-hidden="true">→</span></a>' +
      '</div>';

    bindModalEvents(body);
  }

  function showQvSlide(i) {
    var images = qvState.images || [];
    if (i < 0 || i >= images.length || i === qvState.mediaIdx) return;
    qvState.mediaIdx = i;
    var root = document.getElementById('atc-qv');
    if (!root) return;
    var track = root.querySelector('.atc-qv__media-track');
    if (track) track.style.transform = 'translateX(-' + i * 100 + '%)';
    root.querySelectorAll('.atc-qv__media-slide').forEach(function (s, idx) {
      s.classList.toggle('is-active', idx === i);
    });
    root.querySelectorAll('.atc-qv__dot').forEach(function (d, idx) {
      d.classList.toggle('is-active', idx === i);
    });
  }

  function bindModalEvents(body) {
    body.querySelectorAll('[data-option-index][data-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = Number(btn.getAttribute('data-option-index'));
        var val = btn.getAttribute('data-value');
        qvState.selected[idx] = val;
        var v = findVariant(qvState.product, qvState.selected);
        if (!v) {
          for (var i = idx + 1; i < qvState.selected.length; i++) {
            var avail = availableValues(qvState.product, i, qvState.selected);
            var first = Object.keys(avail)[0];
            if (first) qvState.selected[i] = first;
          }
        }
        renderModal({ fromVariant: true });
      });
    });

    body.querySelectorAll('[data-atc-media]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = Number(btn.getAttribute('data-atc-media')) || 0;
        qvState.baseMediaIdx = i;
        showQvSlide(i);
      });
    });

    var gallery = body.querySelector('[data-atc-qv-gallery]');
    if (gallery && (qvState.images || []).length > 1) {
      var prefersHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (prefersHover) {
        gallery.addEventListener('mousemove', function (e) {
          var rect = gallery.getBoundingClientRect();
          var count = qvState.images.length;
          var next = Math.min(Math.floor(((e.clientX - rect.left) / rect.width) * count), count - 1);
          if (next < 0) next = 0;
          showQvSlide(next);
        });
        gallery.addEventListener('mouseleave', function () {
          showQvSlide(qvState.baseMediaIdx || 0);
        });
      }
    }

    body.querySelectorAll('[data-atc-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = Number(btn.getAttribute('data-atc-qty'));
        qvState.qty = Math.max(1, (qvState.qty || 1) + delta);
        var input = body.querySelector('[data-atc-qty-input]');
        if (input) input.value = qvState.qty;
      });
    });

    var qtyInput = body.querySelector('[data-atc-qty-input]');
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        qvState.qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        qtyInput.value = qvState.qty;
      });
    }

    var addBtn = body.querySelector('[data-atc-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variant = findVariant(qvState.product, qvState.selected);
        if (!variant || !variant.available) return;
        addToCart(variant.id, qvState.qty, addBtn);
      });
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('Ürün yüklenemedi');
        return r.json();
      })
      .then(function (data) {
        productCache[handle] = data;
        return data;
      });
  }

  function openQuickView(handle) {
    openModal();
    setLoading();
    fetchProduct(handle)
      .then(function (product) {
        qvState.product = product;
        qvState.qty = 1;
        qvState.mediaIdx = 0;
        qvState.baseMediaIdx = 0;
        qvState.images = [];
        var first = product.variants.find(function (v) {
          return v.available;
        }) || product.variants[0];
        qvState.selected = (product.options || []).map(function (opt, i) {
          return first ? first['option' + (i + 1)] : null;
        });
        renderModal({ fromVariant: true });
      })
      .catch(function (err) {
        setLoading(
          '<div class="atc-qv__loading">' +
            escapeHtml(err.message || 'Bir hata oluştu') +
            '</div>'
        );
      });
  }

  function addToCart(variantId, quantity, button) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', String(quantity || 1));

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (s) {
          return s.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    if (button) {
      button.classList.add('is-loading');
      button.disabled = true;
    }

    var errEl = document.querySelector('[data-atc-error]');
    if (errEl) {
      errEl.hidden = true;
      errEl.textContent = '';
    }

    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript',
      },
      body: formData,
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        if (response.status) {
          var msg = response.description || response.message || 'Eklenemedi';
          if (errEl) {
            errEl.hidden = false;
            errEl.textContent = msg;
          } else {
            alert(msg);
          }
          return;
        }

        closeModal();

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else if (window.routes && window.routes.cart_url) {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function () {
        if (errEl) {
          errEl.hidden = false;
          errEl.textContent = 'Sepete eklenirken bir hata oluştu.';
        }
      })
      .finally(function () {
        if (button) {
          button.classList.remove('is-loading');
          button.disabled = false;
        }
      });
  }

  function onQuickAddClick(e) {
    var btn = e.target.closest('[data-atc-quickadd]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var handle = btn.getAttribute('data-handle');
    var mode = btn.getAttribute('data-mode') || 'options';
    var variantId = btn.getAttribute('data-variant-id');

    if (mode === 'direct' && variantId) {
      addToCart(variantId, 1, btn);
      return;
    }

    if (!handle) {
      var card = btn.closest('.atc-card');
      handle = card && card.getAttribute('data-product-handle');
    }
    if (!handle) return;
    openQuickView(handle);
  }

  document.addEventListener('click', onQuickAddClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
